var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personalizedType !== 'clipartCategory')?_c('FormulateInput',{attrs:{"name":_vm.layer.id,"label":_vm.label,"shapes":_vm.layer.shapes[0]['file']['key'],"type":"imageshape","aspectRatio":_vm.aspectRatio}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfe42422","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ImageShapeField.vue
// module id = 223
// module chunks = 0